import React from 'react';

const branchColors = {
    main: '#3fb950',      // Green
    work: '#f78166',      // Orange
    project: '#bc8cff',   // Purple
    course: '#d2a8ff',    // Light Purple
    education: '#388bfd', // Blue
};

const GitGraphViewer = ({ content }) => {
    let commits = [];
    try {
        commits = JSON.parse(content);
    } catch (e) {
        return <div className="p-4 text-red-500">Failed to render Git Graph: Invalid JSON</div>;
    }

    const ROW_HEIGHT = 28;
    const COLUMN_WIDTH = 14;
    const DOT_RADIUS = 4;

    const renderGraphCell = (commit, index) => {
        const activeBranches = commit.activeBranches || [];
        const color = branchColors[commit.type] || branchColors.main;
        const cx = 10 + commit.track * COLUMN_WIDTH;
        const cy = ROW_HEIGHT / 2;

        const paths = [];

        // Draw continuous lines for all active branches in this row
        activeBranches.forEach((branchTrack) => {
            const lineX = 10 + branchTrack.track * COLUMN_WIDTH;
            const branchColor = branchColors[branchTrack.type] || '#858585';

            // If it's the branch that is terminating/starting, handle it
            if (branchTrack.track === commit.track) {
                if (!commit.isEnd) {
                    // line going down
                    paths.push(<line key={`down-${branchTrack.track}`} x1={lineX} y1={cy} x2={lineX} y2={ROW_HEIGHT} stroke={branchColor} strokeWidth="2" />);
                }
                if (!commit.isStart) {
                    // line going up
                    paths.push(<line key={`up-${branchTrack.track}`} x1={lineX} y1={0} x2={lineX} y2={cy} stroke={branchColor} strokeWidth="2" />);
                }
            } else {
                // parallel continuous branch
                paths.push(<line key={`thru-${branchTrack.track}`} x1={lineX} y1={0} x2={lineX} y2={ROW_HEIGHT} stroke={branchColor} strokeWidth="2" />);
            }
        });

        // Draw merges and splits (curved lines)
        if (commit.mergeFromTrack !== undefined) {
            const startX = 10 + commit.mergeFromTrack * COLUMN_WIDTH;
            paths.push(
                <path
                    key="merge"
                    d={`M ${startX} ${ROW_HEIGHT} C ${startX} ${cy}, ${cx} ${cy}, ${cx} ${cy}`}
                    fill="none"
                    stroke={color}
                    strokeWidth="2"
                />
            );
        }

        if (commit.splitToTrack !== undefined) {
            const targetX = 10 + commit.splitToTrack * COLUMN_WIDTH;
            const targetColor = branchColors[commit.splitType] || color;
            paths.push(
                <path
                    key="split"
                    d={`M ${cx} ${cy} C ${targetX} ${cy}, ${targetX} ${ROW_HEIGHT}, ${targetX} ${ROW_HEIGHT}`}
                    fill="none"
                    stroke={targetColor}
                    strokeWidth="2"
                />
            );
        }

        return (
            <svg width="100%" height={ROW_HEIGHT} className="block">
                {paths}
                <circle cx={cx} cy={cy} r={DOT_RADIUS} fill={color} stroke="#1e1e1e" strokeWidth="2" />
            </svg>
        );
    };

    return (
        <div className="flex-1 overflow-auto bg-[var(--bg-primary)] p-0 custom-scrollbar font-sans text-[13px] text-[#cccccc]">
            <div className="sticky top-0 bg-[#252526] border-b border-[#2b2b2b] z-10 flex text-[11px] uppercase tracking-wider text-[#858585] py-1">
                <div className="w-[120px] px-4 font-normal">Graph</div>
                <div className="flex-1 px-4 font-normal">Description</div>
                <div className="w-[120px] px-4 font-normal">Date</div>
                <div className="w-[100px] px-4 font-normal">Author</div>
                <div className="w-[80px] px-4 font-normal">Commit</div>
            </div>
            <div className="flex flex-col min-w-max pb-10">
                {commits.map((commit, i) => (
                    <div
                        key={i}
                        className="flex items-center hover:bg-[#2a2d2e] cursor-pointer transition-colors"
                        style={{ height: `${ROW_HEIGHT}px` }}
                    >
                        <div className="w-[120px] h-full flex items-center justify-start pl-4 relative">
                            {renderGraphCell(commit, i)}
                        </div>
                        <div className="flex-1 px-4 flex items-center overflow-hidden whitespace-nowrap text-ellipsis">
                            <span className="font-semibold text-[#e8e8e8] mr-2 truncate flex-shrink-0">{commit.title}</span>
                            <span className="text-[#858585] truncate">{commit.subtitle}</span>
                        </div>
                        <div className="w-[120px] px-4 text-[#858585] truncate">{commit.date}</div>
                        <div className="w-[100px] px-4 text-blue-400 truncate">Sami</div>
                        <div className="w-[80px] px-4 text-[#858585] font-mono truncate">{commit.hash}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GitGraphViewer;
